import BroadcastTable from 'components/BroadcastTable/BroadcastTable'
import React from 'react'

const SectionBroadcastTable: React.FC = () => {
  return <BroadcastTable />
}

export default SectionBroadcastTable
